import { render, staticRenderFns } from "./IndividualProgressBarStepItem.vue?vue&type=template&id=841a3532"
import script from "./IndividualProgressBarStepItem.vue?vue&type=script&lang=js"
export * from "./IndividualProgressBarStepItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../@coac/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports